import { render } from "./assets-table.vue?vue&type=template&id=0057fa10"
import script from "./assets-table.vue?vue&type=script&lang=js"
export * from "./assets-table.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__